/*
		ajax.js,
			Ajax functions. Support for asynchronous get and post requests (uses callbacks).
 */

var Browser = require('./browser.js');

var Ajax = module.exports = {

	request: function(callback) {
		var http_request = false;

		if(! Browser.isIE) { // Mozilla, Safari,IE7,...
			http_request = new XMLHttpRequest();
		}
		else if(window.ActiveXObject) { // IE6
			try {
				http_request = new ActiveXObject("Msxml2.XMLHTTP");
			}
			catch (e) {
				try {
					http_request = new ActiveXObject("Microsoft.XMLHTTP");
				}
				catch (e) {}
			}
		}

		if(http_request) {
			http_request.onreadystatechange = function() {
				if(http_request.readyState == 4) {
					var data, stat, stattxt;
					try {
						data = http_request.responseText;
						stat = http_request.status;
						stattxt = http_request.statusText;
						xml = http_request.responseXML;
					}
					catch(e) {
						/* network error */
						data = null;
						stat = 0;
						stattxt = 'Network error';
						xml = null;
					}
					callback(data, stat, stattxt, xml);
				}
			};
		}

		return http_request;
	},

	get: function(url, callback) {
		var req = Ajax.request(callback);
		if(! req)
			return false;
		req.open('GET', url, true);
		req.send(null);
		return true;
	},

	post: function(url, data, callback) {
		var req = Ajax.request(callback);
		if(! req)
			return false;
		req.open('POST', url, true);
		req.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
		req.send(data);
		return true;
	},

	encode: function(params) {
		var data = '';
		for(var i = 0; i < params.length; i++) {
			if(i != 0)
				data += "&";
			data += params[i][0] + "=" + encodeURIComponent(params[i][1]);
		}
		return data;
	}
};

